export default "__VITE_ASSET__CU7R9Ahe__"